import {createStore} from 'vuex'
import estimate from "@/store/modules/estimate"
import debt from "@/store/modules/debt";
import moneyDelivery from "@/store/modules/moneyDelivery";
import pawnBook from "@/store/modules/pawnBook";
import pawns from "@/store/modules/pawns";
import location from "@/store/modules/location";
import vacancies from "@/store/modules/vacancies";
import catalog from "@/store/modules/catalog";
import user from "@/store/modules/user";
import ordering from "@/store/modules/ordering";
import game from "@/store/modules/game";
import modals from "@/store/modules/modals";
import Fetch from "@/utils/Fetch";
import reviews from "@/store/modules/reviews";
import notifications from "@/store/modules/notifications";

let documents = {
    'policy': '',
    'personal-data': '',
    'effects-notion': '',
};
// Если в LocalStorage есть documents-list и с момент последнего "запоминания" прошло меньше 1 часа - используем данные из localStorage
if (localStorage.getItem('documents-list-ts') && localStorage.getItem('documents-list-ts') > +(new Date) - 60*60*1000) {
    documents = JSON.parse(localStorage.getItem('documents-list')) || documents;
}

export default createStore({
    state: {
        documents,
        popupSuccessData: {
            title: '',
            message: ''
        },
        popupHelpData: {
            title: 'Узнать больше',
            ymGoal: ''
        },
        popupPromoData: {
            title: 'Узнать больше',
            promo_id: null,
            ymGoal: ''
        },
        popupWelcome: null,
        isLoading: false,
        loadingPool: new Set(),
    },
    mutations: {
        startLoading(state, name) {
            state.loadingPool.add(name)
            if (!state.isLoading) state.isLoading = true
        },
        stopLoading(state, name) {
            if (state.loadingPool.has(name)) {
                state.loadingPool.delete(name)
            } else {
                console.error(`${name} : не найдено в пуле загрузки`)
            }
            if (!state.loadingPool.size) {
                state.isLoading = false
            }
        },
        setLoading(state, value) { state.isLoading = value},
        setPopupSuccessData(state, {title, message}) {
            if (!title && !message) return
            state.popupSuccessData.title = title
            state.popupSuccessData.message = message
        },
        setDocuments(state, data) {
            if (data) {
                Object.entries(data).forEach(([key, value]) => {
                    if (key === 'policy') {
                        state.documents[key] = window.location.hostname === "avtolombard-fianit.ru" ? value : '/politika-konfidentsialnosti/'
                    } else {
                        state.documents[key] = value
                    }
                })
                localStorage.setItem('documents-list', JSON.stringify(state.documents));
                localStorage.setItem('documents-list-ts', +(new Date));
            }
        },
        setPopupHelpData(state, {title, ymGoal}) {
            state.popupHelpData.title = title
            if (ymGoal) {
                state.popupHelpData.ymGoal = ymGoal
            }
        },
        setPopupPromoData(state, {title, promoId, ymGoal}) {
            state.popupPromoData.title = title
            state.popupPromoData.promo_id = promoId
            state.popupPromoData.ymGoal = ymGoal
        },
        setPopupWelcome(state, payload) {
            let isEmpty = Object.values(payload).some(i => {
                if (Array.isArray(i)) return i.length
                else return Boolean(i)
            })
            if (isEmpty) {
                state.popupWelcome = {...payload}
            }
        },
    },
    actions: {
        async loadDocuments({commit, state}) {
            if (state.documents.policy) return
            let response = await Fetch('service/documents/')
            if (response.success) {
                commit('setDocuments', response.data)
            }
        },
        async loadPopupWelcome({commit}, code) {
            let response = await Fetch(`service/welcome-modal/${code}/`)
            if (response.success) {
                commit('setPopupWelcome', response.data)
            }
        },
    }
    ,
    getters: {
        getPopupSuccessData: state => state.popupSuccessData,
        getPopupHelpData: state => state.popupHelpData,
        getPopupPromoData: state => state.popupPromoData,
        getDocuments: state => state.documents,
        getPopupWelcome: state => state.popupWelcome,
        isLoading: state => state.isLoading,
        
        isActionPending: (state) => (actionNames) => {
            if (Array.isArray(actionNames)) {
                return actionNames.some(name => state.loadingPool.has(name));
            }
            return state.loadingPool.has(actionNames);
        },
        isDonskoy: () => ['donskoylombard.ru', 'dl.fl-test.xpage.dev', 'dl.fl.localhost'].includes(window.location.hostname)
    },
    modules: {
        estimate,
        debt,
        moneyDelivery,
        pawnBook,
        pawns,
        location,
        user,
        vacancies,
        catalog,
        ordering,
        game,
        modals,
        reviews,
        notifications
    }
})
